import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const GROUP_LINK = "https://chat.whatsapp.com/H9jkMRIbALl7jk9SB2kgOA";

const WhatsAppGroupButton = () => {
  const { t } = useTranslation();

  const handleClick = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(t("whatsapp.intro_template"));
      }
    } catch (error) {
      console.error("Failed to copy WhatsApp intro message:", error);
    }

    window.open(GROUP_LINK, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="fixed bottom-5 ltr:right-5 rtl:left-5 z-[999] flex items-center gap-2">
      <div className="rounded-full bg-[#128C7E] px-3 py-2 text-xs sm:text-sm font-semibold text-white shadow-lg">
        {t("whatsapp.join_teachers_group")}
      </div>
      <button
        type="button"
        onClick={handleClick}
        aria-label={t("whatsapp.aria_join_teachers_group")}
        title={t("whatsapp.join_teachers_group")}
        className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:scale-105 hover:bg-[#20b959] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
      >
        <FaWhatsapp size={30} />
      </button>
    </div>
  );
};

export default WhatsAppGroupButton;
